export default function() {
  this.searchPlaces = function(address, callback) {
    window.axios.get(window.langtag_path+'/search_places.json', {params: {address: address}})
      .then((response) => {
        console.log(response);
        callback(response.data.places, response.data.type);
      });
  }
}
